import axios from '../../../../utils/request';

function GET_AROLE(params) {
    return axios.get("/member/AInquiryIpSetting/index",{
        params: {
            page:params
        }
    } )
}
function SUBMIT_ADD(params) {
    return  axios.post("/member/AInquiryIpSetting/addPost",{...params} )
}
function EDIT_DATA(params) {
    return  axios.post("/member/AInquiryIpSetting/edit",  {
            ...params
        }  )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/member/AInquiryIpSetting/editPost",{...params} )
}
function DELE(params) {
    return  axios.get("/member/AInquiryIpSetting/delete",{
        params: {
            ids:params
        }
    } )
}


export default {
    GET_AROLE,
    SUBMIT_ADD,
    EDIT_DATA,
    SUBMIT_EDIT,
    DELE,
};